import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/estabelecimento-rural`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function getRuralEstablishments({
  page = 1,
  perPage = 10,
  filters = {},
  relations = "",
  filtersRelations = {},
}) {
  const url = new URL(path);

  // Recuperando os filtros
  Object.entries(filters).forEach(([name, value]) =>
    url.searchParams.append(`filter[${name}]`, value)
  );

  // Recuperando os filtros das relações
  Object.entries(filtersRelations).forEach(([relation, relationFilter]) =>
    Object.entries(relationFilter).forEach(([fieldName, value]) =>
      url.searchParams.append(
        `filtersRelations[${relation}][${fieldName}]`,
        value
      )
    )
  );

  url.searchParams.append("page", page);
  url.searchParams.append("perPage", perPage);
  if (relations) url.searchParams.append("relations", relations);

  return search(decodeURIComponent(url), "GET", headers);
}

export async function storeRuralEstablishments({ body }) {
  const url = new URL(path);

  return search(decodeURIComponent(url), "POST", headers, body);
}

export async function updateRuralEstablishments({ body, establishmentId }) {
  const url = new URL(`${path}/${establishmentId}`);

  return search(decodeURIComponent(url), "PUT", headers, body);
}
